import { gql } from "@apollo/client"

const GET_REPORT_WAITING_LIST_XLS_DOWNLOAD_LINK = gql`
  query ($event_id: ID!) {
    reportWaitingListXls(event_id: $event_id) {
      filename
      type
      url
    }
  }
`

export { GET_REPORT_WAITING_LIST_XLS_DOWNLOAD_LINK }
